export default __webpack_public_path__ + "static/media/icon-512x512.e2ec0896.png";